import {
  GOOGLE_PERFORMANCE_URL,
  NICOTINE_QUITLINE_URL,
  RESOURCE_COORDINATOR_URL,
} from './urlsToHandleWithInternalNavigation'

export const WELLNESS_TOOLKIT_BASE_ROUTE = '/secure/wellness/toolkit'
export const NEURODIVERSITY_BASE_ROUTE = '/center-of-excellence/neurodiversity'
export const NEURODIVERSITY_SECURE_BASE_ROUTE = `/secure${NEURODIVERSITY_BASE_ROUTE}`
export const HEALTH_CHALLENGES_BASE_ROUTE = '/health-challenges'
export const HEALTH_CHALLENGES_SECURE_BASE_ROUTE = `/secure${HEALTH_CHALLENGES_BASE_ROUTE}`
export const WOMENS_HEALTH_BASE_ROUTE = `/womens-health`
export const WOMENS_HEALTH_SECURE_BASE_ROUTE = `/secure${WOMENS_HEALTH_BASE_ROUTE}`

export const PAGE_ROUTES = {
  SECURE_INDEX: '/secure/index',
  HOMEBASE: '/secure/index/search-care',
  SEARCH_CARE: { BENEFITS: '/secure/index/search-care/benefits' },
  REGISTRATION_ONBOARDING: '/secure/index/account-info/background-info',
  FAVORITED_PROVIDERS: '/secure/index/favorited-providers',
  EMAILS_REDIRECT: '/secure/index/emails-redirect',
  ABOUT: 'about',
  ABOUT_CHILD: 'about-child',
  ABOUT_OTHER_ADULT: 'about-other-adult',
  ASSIGNMENTS_NEW: '/secure/assignments', // TODO: will need to figure out what to do for this since this is used for mapping but web has refs to /secure/index/assignments
  MATCHES: 'matches',
  COACHES: 'coaches',
  CLINICAL_DATA_SHARING: '/secure/index/clinical-data-sharing',
  COACHING: {
    COACHES: 'coaching/coaches',
    COACH: 'coaching/coach',
    DEFAULT: 'coaching',
    LOCATION_MATCHER: 'coaching/location',
  },
  SSO_REGISTRATION: 'ssoregistration',
  SSO_REGISTRATION_APPLE: 'ssoregistration/apple',
  SSO_REGISTRATION_GOOGLE: 'ssoregistration/google',
  CONTACT_CARE_TEAM: 'contact-care-team',
  CONTACT_CARE_TEAM_CONFIRMATION: 'contact-care-team/confirmation',
  CARE_TEAM_PHONE_NUMBERS: '/care-team-phone-numbers',
  WORKLIFE_SERVICES: '/worklife',
  WORKLIFE_SERVICES_CONTACT_CARE_INTERNATIONAL: '/worklife-care-team-numbers',
  WORKLIFE_SERVICES_SECURE: '/secure/index/worklife',
  CONTACT_CARE_ADVOCATE_FORM: '/secure/onboard/care-advocate-consultation',
  CONTACT_CARE_ADVOCATE_CONFIRMATION: '/secure/onboard/care-advocate-consultation/confirmation',
  ZERO_SEARCH_RESULTS_REDIRECT: 'zero-search-results-redirect',
  MATCH_LOCATION: 'match-location',
  T1_MULTI_PROVIDERS: 't1-multi-providers',
  LATEST_PROVIDER_MATCHES: 'latest-provider-matches',
  UNSUPPORTED_OPTION: 'unsupported',
  VIDEO_THERAPY: 'video-therapy',
  PROVIDER: 'provider',
  PROVIDER_PROFILE: function (id: string) {
    return `/secure/index/provider/${id}`
  },
  PROFILE: {
    DEFAULT: '/secure/profile',
    ELIGIBILITY: '/secure/profile/eligibility',
    SETTINGS: '/secure/profile/settings',
    SESSION_HISTORY: '/secure/profile/session-history',
    HEALTH_PLAN_AND_PAYMENTS: '/secure/profile/health-plan-and-payments',
    PRIVACY_AND_LEGAL: '/secure/profile/privacy-and-legal',
    CHANGE_EMAIL: '/secure/profile/settings/email/change',
    RESET_PASSWORD: '/secure/profile/forgot-password',
    ENROLL_MFA: '/secure/profile/settings/enrollMFA',
    VERIFY_MFA: '/secure/profile/settings/verifyMFA',
    MFA_ENABLED: '/secure/profile/settings/MFAEnabled',
    UPDATE_LOCATION: '/secure/profile/settings/update-location',
    UPDATE_PHONE_NUMBER: '/secure/profile/settings/update-phone-number',
    UPDATE_LANGUAGE: '/secure/profile/settings/language/change',
    UPDATE_NOTIFICATION_SETTINGS: '/secure/profile/settings/update-notification-settings',
    UPDATE_LYRA_UPDATES_SETTINGS: '/secure/profile/settings/update-notification-settings/lyra-updates',
    UPDATE_PERSONAL_INFORMATION: '/secure/profile/update-personal-information',
    UPDATE_CHILD_INFORMATION: '/secure/profile/update-child-information',
    UPDATE_PERSONAL_INFORMATION_QUESTIONNAIRE: '/secure/profile/update-info-questionnaire',
    UPDATE_THEME: '/secure/profile/settings/theme/change',
    UPDATE_CUSTOM_NOTIFICATIONS: '/secure/profile/settings/update-custom-notifications',
    COVERAGE_CHECK: '/secure/coverage-check/profile',
    ADD_FAMILY_MEMBER: '/secure/profile/add-dependent-information',
    DEPENDENT_CONFIRMATION: '/secure/profile/dependent-confirmation',
    SELF_MANAGED_CONFIRMATION: '/secure/profile/self-managed-dependent-confirmation',
    TRANSFER_ACCOUNT: {
      FIND_EMPLOYER: '/secure/profile/eligibility/transfer-account/find-employer',
    },
  },
  COACHING_SESSION_MODALITY_SELECTION: 'session-modality',
  APPOINTMENT_SELECTION: function (id: string) {
    return `provider/${id}/schedule`
  },
  APPOINTMENT_LOGISTICS: function (id: string) {
    return `provider/${id}/appointment`
  },
  APPOINTMENT_REQUEST: function (id: string) {
    return `provider/${id}/request`
  },
  LOCATION_NOT_SUPPORTED: function (id: string) {
    return `provider/${id}/location-not-supported`
  },
  MORE_OPTIONS: 'more-options',
  HOME: '/secure/index',
  ASSIGNMENTS: 'assignments',
  SESSIONS: '/secure/index/sessions',
  SESSION_SELECTION: 'sessions/reschedule',
  SESSION_DETAILS: 'sessions/details',
  MODALITY_QUESTIONNAIRE: {
    INTRO: 'modality-questionnaire',
    SURVEY: 'modality-questionnaire/survey',
    RESULTS: 'modality-questionnaire/results',
  },
  ORIENTATION_ABOUT_US: (id: string) => `orientation/${id}/about-us`,
  ORIENTATION_ABOUT_YOU: (id: string) => `orientation/${id}/about-you`,
  MEDS_OPTIONS_EXPLAINED: {
    ONBOARD: '/secure/onboard/meds-options-explained',
    DIRECT_BOOKING: 'secure/index/meds-options-explained',
  },
  HPI_COVERAGE_CHECK: {
    ONBOARD: {
      HEALTH_PLAN_FORM: '/secure/coverage-check/onboard/plan-info',
      APPOINTMENT_HEALTH_PLAN_FORM: '/secure/coverage-check/onboard/appointment-plan-info',
      APPOINTMENT_PAYMENT_INFO_FORM: '/secure/coverage-check/onboard/appointment-payment-info',
      TREATMENT_HEALTH_PLAN_FORM: '/secure/coverage-check/onboard/treatment-plan-info',
      FOR_CHILD_HEALTH_PLAN_FORM: '/secure/coverage-check/onboard/for-child-plan-info',
    },
    OPTION: {
      HEALTH_PLAN_FORM: '/secure/coverage-check/option/plan-info',
    },
    PROFILE: {
      HEALTH_PLAN_FORM: '/secure/coverage-check/profile/plan-info',
      PAYMENT_INFO_FORM: '/secure/coverage-check/profile/payment-info',
      INFRACTION_PAYMENT_INFO_FORM: '/secure/coverage-check/profile/infraction-payment-info',
    },
    EMAIL: {
      DEFAULT: '/secure/coverage-check/email',
      HEALTH_PLAN_FORM: '/secure/coverage-check/email/plan-info',
      APPOINTMENT_PAYMENT_INFO_FORM: '/secure/coverage-check/email/appointment-payment-info',
      APPOINTMENT_HPI_OVERVIEW: '/secure/coverage-check/email/appointment-hpi-overview',
    },
    PROVIDER: {
      HEALTH_PLAN_FORM: '/secure/coverage-check/provider/plan-info',
      PAYMENT_INFO_FORM: '/secure/coverage-check/provider/payment-info',
    },
    REMINDER: {
      HEALTH_PLAN_FORM: '/secure/coverage-check/reminder/plan-info',
      INFRACTION_PAYMENT_INFO_FORM: '/secure/coverage-check/reminder/infraction-payment-info',
    },
    HEALTH_PLAN_AND_PAYMENT_INFO_OVERVIEW: 'health-plan-and-payment-information-overview',
    HEALTH_PLAN_FORM: 'plan-info',
    PAYMENT_INFO_FORM: 'payment-info',
    INFRACTION_PAYMENT_INFO_FORM: 'infraction-payment-info',
    HEALTH_PLAN_PENDING: 'pending',
    HEALTH_PLAN_INELIGIBLE: 'ineligible',
    HEALTH_PLAN_INELIGIBLE_DIRECT_PATH: 'ineligible-direct-path',
    VIEW_OTHER_OPTIONS: 'view-other-options',
    HIGH_ALERT_RESOURCES: 'resources',
    APPOINTMENT_HEALTH_PLAN_FORM: 'appointment-plan-info',
    APPOINTMENT_PAYMENT_INFO_FORM: 'appointment-payment-info',
    TREATMENT_HEALTH_PLAN_FORM: 'treatment-plan-info',
    FOR_CHILD_HEALTH_PLAN_FORM: 'for-child-plan-info',
    APPOINTMENT_HPI_OVERVIEW: 'appointment-hpi-overview',
  },
  CARE_NAVIGATOR_OPTIONS: {
    DEFAULT: 'care-navigator-options',
    SECURE_INDEX: '/secure/index/care-navigator-options',
    ONBOARD: '/secure/onboard/care-navigator-options',
  },
  ONBOARD_BASE: '/secure/onboard',
  ONBOARD: {
    SUMMARY: '/secure/onboard/summary',
    ABOUT: '/secure/onboard/about',
    ABOUT_CHILD: '/secure/onboard/about-child',
    ABOUT_CHILD_INFO: '/secure/onboard/about-child/info',
    MATCH_LOCATION: '/secure/onboard/match-location',
  },
  PATHWAYS: {
    FORKED_TRIAGE: '/pathways/care-options',
    SELF_CARE: '/pathways/self-care-options',
    ESSENTIALS_HOMEPAGE_WIDGET: '/pathways/essentials-homepage-widget',
  },
  WELLNESS_CHECK_IN: {
    DEFAULT: '/wellness-check-in',
    PREVIEW: '/wellness-check-in/preview',
    RESULTS: '/secure/wellness-check-in/results',
  },
  ESSENTIALS: '/secure/index/essentials',
  ESSENTIALS_ARTICLES: '/essentials/articles',
  ESSENTIALS_EVENTS: '/essentials/events',
  LOGIN: '/login',
  APPOINTMENT_CONFIRMATION_PARENT_LED_TEEN: 'appointment/confirmation/parent-led-teen',
  COMPLEX_CARE: '/secure/index/complex-care',
  FAMILY_CARE_OPTIONS: '/secure/index/family-care-options',
  ELECTION: '/election',
  FAMILY_HUB: `${WELLNESS_TOOLKIT_BASE_ROUTE}/family`,
  UNSUBSCRIBE: '/unsubscribe',
  CARE_INITIAL: '/secure/index/care/initial',
  SOCIAL_CARE: RESOURCE_COORDINATOR_URL,
  NICOTINE_QUITLINE: NICOTINE_QUITLINE_URL,
  REGISTER: '/register/connect',
  REGISTER_VERIFY: '/register/verify',
  MICROSITE: '/',
  GOOGLE_PERFORMANCE: GOOGLE_PERFORMANCE_URL,
  VERIFY_ATTESTATION: '/verify-attestation',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  COMING_SOON_MICROSITE: '/comingSoon',
  CENTER_OF_EXCELLENCE: {
    NEURODIVERSITY: {
      LANDING_PAGE: NEURODIVERSITY_BASE_ROUTE,
      CONTACT_CARE_NAVIGATOR: `${NEURODIVERSITY_SECURE_BASE_ROUTE}/contact-care-navigator`,
      CARE_OPTIONS: `${NEURODIVERSITY_SECURE_BASE_ROUTE}/care-options`,
    },
    HEALTH_CHALLENGES: {
      LANDING_PAGE: HEALTH_CHALLENGES_BASE_ROUTE,
      CARE_OPTIONS: `${HEALTH_CHALLENGES_SECURE_BASE_ROUTE}/care-options`,
    },
    WOMENS_HEALTH: {
      LANDING_PAGE: WOMENS_HEALTH_BASE_ROUTE,
      CARE_OPTIONS: `${WOMENS_HEALTH_SECURE_BASE_ROUTE}/care-options`,
    },
  },
  PARENTAL_LEAVE_COACHING: '/secure/index/parental-leave-coaching',
  TOOLKIT_DIRECTORY: '/secure/toolkits',
  HEALTH_CHALLENGES_TOOLKIT: HEALTH_CHALLENGES_BASE_ROUTE,
}

export enum APP_SCREEN {
  PROFILE_SESSION_HISTORY = 'ProfileSessionHistory',
  PROFILE_ELIGIBILITY = 'ProfileEligibility',
  PROFILE_PRIVACY_LEGAL = 'ProfilePrivacyLegal',
  PROFILE_HOMEPAGE = 'ProfileHomepage',
  PROFILE_SETTINGS = 'ProfileSettings',
  PROFILE_UPDATE_NOTIFICATION_SETTINGS = 'ProfileUpdateNotificationSettings',
  PROFILE_UPDATE_LYRA_UPDATES = 'ProfileUpdateLyraUpdates',
  CLINICAL_DATA_SHARING = 'ClinicalDataSharing',
  CLINICAL_DATA_SHARING_CREATE_CODE = 'ClinicalDataSharingCreateCode',
  CLINICAL_DATA_SHARING_CONFIRM = 'ClinicalDataSharingConfirm',
  CLINICAL_DATA_SHARING_REQUEST_RECORD = 'ClinicalDataSharingRequestRecord',
  PROFILE_CHANGE_EMAIL = 'ProfileChangeEmail',
  PROFILE_UPDATE_CUSTOM_NOTIFICATIONS = 'ProfileUpdateCustomNotifications',
  PROFILE_UPDATE_PHONE_NUMBER = 'ProfileUpdatePhoneNumber',
  PROFILE_UPDATE_LOCATION = 'ProfileUpdateLocation',
  PROFILE_UPDATE_PERSONAL_INFORMATION = 'ProfileUpdatePersonalInformation',
  HEALTH_PLAN_AND_PAYMENT_INFORMATION = 'HealthPlanAndPaymentInformation',
  HEALTH_PLAN_INFORMATION = 'HealthPlanInformation',
  HEALTH_PLAN_ELIGIBILITY = 'HealthPlanEligibility',
  HEALTH_PLAN_ELIGIBILITY_PENDING = 'HealthPlanEligibilityPending',
  PROFILE_PAYMENT = 'ProfilePayment',
  PROFILE_INFRACTION_PAYMENT = 'ProfileInfractionPayment',
  PROFILE_FORGOT_PASSWORD = 'ProfileForgotPassword',
  PROFILE_DISPLAY_LANGUAGE = 'ProfileDisplayLanguage',
  PROFILE_TRANSFER_ACCOUNT_FIND_EMPLOYER = 'ProfileTransferAccountFindEmployer',
  TRANSFER_ACCOUNT_CHOOSE_MULTI_INSTANCE_SUBPOPULATION = 'TransferAccountChooseMultiInstanceSubpopulation',
  TRANSFER_ACCOUNT_CHOOSE_ONE_MICROSITE_SUBPOPULATION = 'TransferAccountChooseOneMicrositeSubpopulation',
  TRANSFER_ACCOUNT_CONFIRMATION = 'TransferAccountConfirmation',
  PROFILE_MFA = 'ProfileMFA',
  PROFILE_UPDATE_BASIC_INFO_VERIFY_EMAIL = 'ProfileUpdateBasicInfoVerifyEmail',
  PROFILE_UPDATE_INFO_QUESTIONNAIRE = 'ProfileUpdateInfoQuestionnaire',
  WORK_LIFE_SERVICES = 'WorkLifeServices',
  TRANSFER_ACCOUNT = 'TransferAccount',
  ASSIGNMENTS = 'Activities',
  ACTIVITY = 'Activity',
  ACTIVITY_OVERVIEW = 'ActivityOverview',
  LESSON = 'Lesson',
  PROFILE_ADD_FAMILY_MEMBER = 'ProfileAddFamilyMember',
  PROFILE_DEPENDENT_CONFIRMATION = 'ProfileDependentConfirmation',
  PROFILE_SELF_MANAGED_DEPENDENT_CONFIRMATION = 'ProfileSelfManagedDependentConfirmation',
  PROFILE_UPDATE_CHILD_INFORMATION = 'ProfileUpdateChildInformation',
  PROVIDER_PROFILE = 'ProviderProfile',
  CARE_INITIAL = 'CareInitial',
  ZOOM_VIDEO_SESSION = 'ZoomVideoSession',
  ESSENTIALS = 'Essentials',
}

export enum APP_ROUTE {
  PROFILE_SESSION_HISTORY = '/secure/profile/session-history',
  PROFILE_ELIGIBILITY = '/secure/profile/eligibility',
  PROFILE_PRIVACY_LEGAL = '/secure/profile/privacy-and-legal',
  PROFILE_HOMEPAGE = '/secure/profile',
  PROFILE_SETTINGS = '/secure/profile/settings',
  PROFILE_UPDATE_NOTIFICATION_SETTINGS = '/secure/profile/settings/update-notification-settings',
  PROFILE_UPDATE_LYRA_UPDATES = '/secure/profile/settings/update-notification-settings/lyra-updates',
  CLINICAL_DATA_SHARING = '/secure/index/clinical-data-sharing',
  CLINICAL_DATA_SHARING_CREATE_CODE = '/secure/index/clinical-data-sharing/create-code',
  CLINICAL_DATA_SHARING_REQUEST_RECORD = '/secure/index/clinical-data-sharing/request-record',
  HEALTH_PLAN_AND_PAYMENT_INFORMATION = '/secure/profile/health-plan-and-payments',
  CLINICAL_DATA_SHARING_CONFIRM = '/secure/index/clinical-data-sharing/confirmation',
  PROFILE_CHANGE_EMAIL = '/secure/profile/settings/email/change',
  PROFILE_UPDATE_CUSTOM_NOTIFICATIONS = '/secure/profile/settings/update-custom-notifications',
  PROFILE_UPDATE_PHONE_NUMBER = '/secure/profile/settings/update-phone-number',
  PROFILE_UPDATE_LOCATION = '/secure/profile/settings/update-location',
  PROFILE_UPDATE_PERSONAL_INFORMATION = '/secure/profile/update-personal-information',
  HEALTH_PLAN_INFORMATION = '/secure/coverage-check/profile/plan-info',
  HEALTH_PLAN_ELIGIBILITY = '/secure/coverage-check/profile/ineligible',
  HEALTH_PLAN_ELIGIBILITY_PENDING = '/secure/coverage-check/profile/pending',
  PROFILE_PAYMENT = '/secure/coverage-check/profile/payment-info',
  PROFILE_INFRACTION_PAYMENT = '/secure/coverage-check/profile/infraction-payment-info',
  PROFILE_FORGOT_PASSWORD = '/secure/profile/forgot-password',
  PROFILE_DISPLAY_LANGUAGE = '/secure/profile/settings/language/change',
  PROFILE_TRANSFER_ACCOUNT_FIND_EMPLOYER = '/secure/profile/eligibility/transfer-account/find-employer',
  TRANSFER_ACCOUNT_CHOOSE_MULTI_INSTANCE_SUBPOPULATION = '/secure/profile/eligibility/transfer-account/choose-subpopulation/redirect',
  TRANSFER_ACCOUNT_CHOOSE_ONE_MICROSITE_SUBPOPULATION = '/secure/profile/eligibility/transfer-account/choose-subpopulation',
  TRANSFER_ACCOUNT_CONFIRMATION = '/secure/profile/eligibility/transfer-account/confirmation',
  PROFILE_MFA = '/secure/profile/settings/enrollMFA',
  PROFILE_UPDATE_BASIC_INFO_VERIFY_EMAIL = '/secure/profile/update-personal-information/verify',
  PROFILE_UPDATE_INFO_QUESTIONNAIRE = '/secure/profile/update-info-questionnaire',
  WORK_LIFE_SERVICES = '/worklife',
  WORK_LIFE_SERVICES_SECURE = '/secure/index/worklife',
  TRANSFER_ACCOUNT = '/secure/profile/eligibility/transfer-account/basic-info',
  ASSIGNMENTS = '/secure/assignments',
  ACTIVITY = '/secure/activity',
  ACTIVITY_OVERVIEW = '/secure/activity-overview',
  LESSON = '/secure/lesson',
  PROFILE_ADD_FAMILY_MEMBER = '/secure/profile/add-dependent-information',
  PROFILE_DEPENDENT_CONFIRMATION = '/secure/profile/dependent-confirmation',
  PROFILE_SELF_MANAGED_DEPENDENT_CONFIRMATION = '/secure/profile/self-managed-dependent-confirmation',
  PROFILE_UPDATE_CHILD_INFORMATION = '/secure/profile/update-child-information',
  PROVIDER_PROFILE_DIRECT_BOOKING = '/secure/index/provider',
  CARE_INITIAL = '/secure/care/initial',
  ZOOM_VIDEO_SESSION = '/secure/video-session',
  ESSENTIALS = '/secure/index/essentials',
}

const routeToScreenMap: { [key in APP_ROUTE]: APP_SCREEN } = {
  [APP_ROUTE.PROFILE_SESSION_HISTORY]: APP_SCREEN.PROFILE_SESSION_HISTORY,
  [APP_ROUTE.PROFILE_ELIGIBILITY]: APP_SCREEN.PROFILE_ELIGIBILITY,
  [APP_ROUTE.PROFILE_PRIVACY_LEGAL]: APP_SCREEN.PROFILE_PRIVACY_LEGAL,
  [APP_ROUTE.PROFILE_HOMEPAGE]: APP_SCREEN.PROFILE_HOMEPAGE,
  [APP_ROUTE.PROFILE_SETTINGS]: APP_SCREEN.PROFILE_SETTINGS,
  [APP_ROUTE.PROFILE_UPDATE_NOTIFICATION_SETTINGS]: APP_SCREEN.PROFILE_UPDATE_NOTIFICATION_SETTINGS,
  [APP_ROUTE.PROFILE_UPDATE_LYRA_UPDATES]: APP_SCREEN.PROFILE_UPDATE_LYRA_UPDATES,
  [APP_ROUTE.CLINICAL_DATA_SHARING]: APP_SCREEN.CLINICAL_DATA_SHARING,
  [APP_ROUTE.CLINICAL_DATA_SHARING_CREATE_CODE]: APP_SCREEN.CLINICAL_DATA_SHARING_CREATE_CODE,
  [APP_ROUTE.CLINICAL_DATA_SHARING_CONFIRM]: APP_SCREEN.CLINICAL_DATA_SHARING_CONFIRM,
  [APP_ROUTE.CLINICAL_DATA_SHARING_REQUEST_RECORD]: APP_SCREEN.CLINICAL_DATA_SHARING_REQUEST_RECORD,
  [APP_ROUTE.PROFILE_CHANGE_EMAIL]: APP_SCREEN.PROFILE_CHANGE_EMAIL,
  [APP_ROUTE.PROFILE_UPDATE_CUSTOM_NOTIFICATIONS]: APP_SCREEN.PROFILE_UPDATE_CUSTOM_NOTIFICATIONS,
  [APP_ROUTE.PROFILE_UPDATE_PHONE_NUMBER]: APP_SCREEN.PROFILE_UPDATE_PHONE_NUMBER,
  [APP_ROUTE.PROFILE_UPDATE_LOCATION]: APP_SCREEN.PROFILE_UPDATE_LOCATION,
  [APP_ROUTE.PROFILE_UPDATE_PERSONAL_INFORMATION]: APP_SCREEN.PROFILE_UPDATE_PERSONAL_INFORMATION,
  [APP_ROUTE.HEALTH_PLAN_AND_PAYMENT_INFORMATION]: APP_SCREEN.HEALTH_PLAN_AND_PAYMENT_INFORMATION,
  [APP_ROUTE.HEALTH_PLAN_INFORMATION]: APP_SCREEN.HEALTH_PLAN_INFORMATION,
  [APP_ROUTE.HEALTH_PLAN_ELIGIBILITY]: APP_SCREEN.HEALTH_PLAN_ELIGIBILITY,
  [APP_ROUTE.HEALTH_PLAN_ELIGIBILITY_PENDING]: APP_SCREEN.HEALTH_PLAN_ELIGIBILITY_PENDING,
  [APP_ROUTE.PROFILE_PAYMENT]: APP_SCREEN.PROFILE_PAYMENT,
  [APP_ROUTE.PROFILE_INFRACTION_PAYMENT]: APP_SCREEN.PROFILE_INFRACTION_PAYMENT,
  [APP_ROUTE.PROFILE_FORGOT_PASSWORD]: APP_SCREEN.PROFILE_FORGOT_PASSWORD,
  [APP_ROUTE.PROFILE_DISPLAY_LANGUAGE]: APP_SCREEN.PROFILE_DISPLAY_LANGUAGE,
  [APP_ROUTE.PROFILE_TRANSFER_ACCOUNT_FIND_EMPLOYER]: APP_SCREEN.PROFILE_TRANSFER_ACCOUNT_FIND_EMPLOYER,
  [APP_ROUTE.TRANSFER_ACCOUNT_CHOOSE_MULTI_INSTANCE_SUBPOPULATION]:
    APP_SCREEN.TRANSFER_ACCOUNT_CHOOSE_MULTI_INSTANCE_SUBPOPULATION,
  [APP_ROUTE.TRANSFER_ACCOUNT_CHOOSE_ONE_MICROSITE_SUBPOPULATION]:
    APP_SCREEN.TRANSFER_ACCOUNT_CHOOSE_ONE_MICROSITE_SUBPOPULATION,
  [APP_ROUTE.TRANSFER_ACCOUNT_CONFIRMATION]: APP_SCREEN.TRANSFER_ACCOUNT_CONFIRMATION,
  [APP_ROUTE.PROFILE_MFA]: APP_SCREEN.PROFILE_MFA,
  [APP_ROUTE.PROFILE_UPDATE_BASIC_INFO_VERIFY_EMAIL]: APP_SCREEN.PROFILE_UPDATE_BASIC_INFO_VERIFY_EMAIL,
  [APP_ROUTE.PROFILE_UPDATE_INFO_QUESTIONNAIRE]: APP_SCREEN.PROFILE_UPDATE_INFO_QUESTIONNAIRE,
  [APP_ROUTE.WORK_LIFE_SERVICES]: APP_SCREEN.WORK_LIFE_SERVICES,
  [APP_ROUTE.WORK_LIFE_SERVICES_SECURE]: APP_SCREEN.WORK_LIFE_SERVICES,
  [APP_ROUTE.TRANSFER_ACCOUNT]: APP_SCREEN.TRANSFER_ACCOUNT,
  [APP_ROUTE.ASSIGNMENTS]: APP_SCREEN.ASSIGNMENTS,
  [APP_ROUTE.ACTIVITY]: APP_SCREEN.ACTIVITY,
  [APP_ROUTE.ACTIVITY_OVERVIEW]: APP_SCREEN.ACTIVITY_OVERVIEW,
  [APP_ROUTE.LESSON]: APP_SCREEN.LESSON,
  [APP_ROUTE.PROFILE_ADD_FAMILY_MEMBER]: APP_SCREEN.PROFILE_ADD_FAMILY_MEMBER,
  [APP_ROUTE.PROFILE_DEPENDENT_CONFIRMATION]: APP_SCREEN.PROFILE_DEPENDENT_CONFIRMATION,
  [APP_ROUTE.PROFILE_SELF_MANAGED_DEPENDENT_CONFIRMATION]: APP_SCREEN.PROFILE_SELF_MANAGED_DEPENDENT_CONFIRMATION,
  [APP_ROUTE.PROFILE_UPDATE_CHILD_INFORMATION]: APP_SCREEN.PROFILE_UPDATE_CHILD_INFORMATION,
  [APP_ROUTE.PROVIDER_PROFILE_DIRECT_BOOKING]: APP_SCREEN.PROVIDER_PROFILE,
  [APP_ROUTE.CARE_INITIAL]: APP_SCREEN.CARE_INITIAL,
  [APP_ROUTE.ZOOM_VIDEO_SESSION]: APP_SCREEN.ZOOM_VIDEO_SESSION,
  [APP_ROUTE.ESSENTIALS]: APP_SCREEN.ESSENTIALS,
}

export const routesEnabledInNativeApp: string[] = [
  APP_ROUTE.CLINICAL_DATA_SHARING,
  APP_ROUTE.CLINICAL_DATA_SHARING_CREATE_CODE,
  APP_ROUTE.CLINICAL_DATA_SHARING_CONFIRM,
  APP_ROUTE.CLINICAL_DATA_SHARING_REQUEST_RECORD,
  APP_ROUTE.WORK_LIFE_SERVICES,
  APP_ROUTE.WORK_LIFE_SERVICES_SECURE,
  APP_ROUTE.TRANSFER_ACCOUNT,
  APP_ROUTE.TRANSFER_ACCOUNT_CHOOSE_MULTI_INSTANCE_SUBPOPULATION,
  APP_ROUTE.TRANSFER_ACCOUNT_CHOOSE_ONE_MICROSITE_SUBPOPULATION,
  APP_ROUTE.TRANSFER_ACCOUNT_CONFIRMATION,
  APP_ROUTE.PROVIDER_PROFILE_DIRECT_BOOKING,
  APP_ROUTE.ZOOM_VIDEO_SESSION,
  // Profile Routes
  APP_ROUTE.PROFILE_HOMEPAGE,
  APP_ROUTE.PROFILE_SETTINGS,
  APP_ROUTE.PROFILE_CHANGE_EMAIL,
  APP_ROUTE.PROFILE_UPDATE_NOTIFICATION_SETTINGS,
  APP_ROUTE.PROFILE_UPDATE_LYRA_UPDATES,
  APP_ROUTE.PROFILE_UPDATE_CUSTOM_NOTIFICATIONS,
  APP_ROUTE.PROFILE_UPDATE_PHONE_NUMBER,
  APP_ROUTE.PROFILE_UPDATE_LOCATION,
  APP_ROUTE.PROFILE_UPDATE_PERSONAL_INFORMATION,
  APP_ROUTE.HEALTH_PLAN_AND_PAYMENT_INFORMATION,
  APP_ROUTE.HEALTH_PLAN_INFORMATION,
  APP_ROUTE.HEALTH_PLAN_ELIGIBILITY,
  APP_ROUTE.HEALTH_PLAN_ELIGIBILITY_PENDING,
  APP_ROUTE.PROFILE_PAYMENT,
  APP_ROUTE.PROFILE_INFRACTION_PAYMENT,
  APP_ROUTE.PROFILE_FORGOT_PASSWORD,
  APP_ROUTE.PROFILE_DISPLAY_LANGUAGE,
  APP_ROUTE.PROFILE_MFA,
  APP_ROUTE.PROFILE_UPDATE_BASIC_INFO_VERIFY_EMAIL,
  APP_ROUTE.PROFILE_UPDATE_INFO_QUESTIONNAIRE,
  APP_ROUTE.PROFILE_ADD_FAMILY_MEMBER,
  APP_ROUTE.PROFILE_DEPENDENT_CONFIRMATION,
  APP_ROUTE.PROFILE_SELF_MANAGED_DEPENDENT_CONFIRMATION,
  APP_ROUTE.PROFILE_UPDATE_CHILD_INFORMATION,
  APP_ROUTE.PROFILE_SESSION_HISTORY,
  APP_ROUTE.PROFILE_ELIGIBILITY,
  APP_ROUTE.PROFILE_PRIVACY_LEGAL,
  APP_ROUTE.PROFILE_TRANSFER_ACCOUNT_FIND_EMPLOYER,
]

export const careRoutes: string[] = [
  APP_ROUTE.ASSIGNMENTS,
  APP_ROUTE.ACTIVITY,
  APP_ROUTE.ACTIVITY_OVERVIEW,
  APP_ROUTE.LESSON,
  APP_ROUTE.CARE_INITIAL,
  APP_ROUTE.ESSENTIALS,
]

export const getRoutesEnabledInNativeApp = (is1LyraEnabledForCareRoutes: boolean) => {
  return [...routesEnabledInNativeApp, ...(is1LyraEnabledForCareRoutes ? careRoutes : [])]
}

/**
 * Check if a route is a messaging route that should render as a mobile screen
 * even when not in routesEnabledInNativeApp.
 *
 * TEMPORARY FIX (ACCOUNT-3816): Messaging routes don't have corresponding web routes
 * (messenger is accessed via MessagesPopover overlay), so they must render
 * as mobile screens to avoid redirecting to non-existent web URLs.
 *
 * @param route - The route path to check (e.g., '/secure/messages', '/secure/chat')
 * @returns true if the route is a messaging route
 */
export const isMessagingRoute = (route: string): boolean => {
  const MESSAGING_ROUTES = ['/secure/messages', '/secure/chat']
  return MESSAGING_ROUTES.some((messagingRoute) => route.toLowerCase() === messagingRoute.toLowerCase())
}

export const screensEnabledInNativeApp = routesEnabledInNativeApp.map((route) => routeToScreenMap[route as APP_ROUTE])

export const ONBOARDING_WELLNESS_GOALS_PATH = '/secure/index/wellness-goals'

export const REDIRECT_URL_PARAM = 'redirectUrl'
export const FROM_URL_REDIRECT_KEY = 'fromUrlRedirect'

/** Destination for unauthenticated users hitting a secure route */
export enum AUTH_LANDING_VALUE {
  REGISTRATION = 'registration',
  LOGIN = 'login',
}
